import R2Image from '@/components/ui/R2Image';

interface ConsultantCardHeaderProps {
  slug: string;
  imageUrl?: string;
  imageStyle?: string;
  name: string;
  compact?: boolean;
  objectFit?: 'cover' | 'contain';
}

const ConsultantCardHeader: React.FC<ConsultantCardHeaderProps> = ({
  slug,
  imageUrl,
  imageStyle,
  name,
  compact = false,
  objectFit,
}) => {
  return (
    <div
      className={`bg-card-gradient relative w-full shrink-0 overflow-hidden ${compact ? 'h-[160px]' : 'h-72'}`}
    >
      <div
        className={`absolute z-10 ${compact ? 'top-3 left-3' : 'top-5 left-5'}`}
      >
        <R2Image
          path="/images/logo/lips-logo.svg"
          alt="Lips Healthcare Logo"
          width={compact ? 28 : 49}
          height={compact ? 28 : 49}
        />
      </div>

      <R2Image
        path={imageUrl || `${slug}.webp`}
        alt={name}
        objectFit={compact ? 'contain' : objectFit}
        className={`object-contain object-bottom ${imageStyle ?? ''}`}
        // compact renders in a 160px-tall box (grids/sliders showing many
        // small cards at once) — a ~107px-wide photo at that height. The
        // previous single sizes value assumed the full-size card's ~280-350px
        // width even in compact mode, so compact-mode cards were requesting
        // an oversized image variant.
        sizes={
          compact
            ? '(max-width: 480px) 130px, 110px'
            : '(max-width: 480px) 224px, (max-width: 1024px) 350px, 280px'
        }
      />
    </div>
  );
};

export default ConsultantCardHeader;
